import { StyledButton, StyledSlot } from './Button.styles';
import type { Props } from './Button.types';

export const Button = ({
  type = 'button',
  size = 'medium',
  format = 'auto',
  asChild,
  ...rest
}: Props) => {
  const Component = asChild ? StyledSlot : StyledButton;

  return <Component type={type} size={size} format={format} {...rest} />;
};
